/* ⛔ TUTOIEMENT / VOUVOIEMENT SELON LA CIBLE DU MODULE (07/10/2026).
   Regle validee par Nawal, qui remplace la partie 1 de PD-12 (« l'apprenant
   est tutoye ») :
   - le champ `cible` d'un module, regle dans l'admin (ContentForm), vaut ""
     (Non defini), "school" (Ecole) ou "corpo" (Corporate) ;
   - Ecole -> tutoiement ; Corporate, Non defini ou champ absent -> vouvoiement ;
   - dans un module, on suit la cible de ce module ; hors module, celle du
     module EN COURS (`actFormation`) ; avant connexion, vous ;
   - le contenu saisi dans l'editeur ne change pas, l'anglais non plus.

   Ce fichier porte les DEUX seules regles du mecanisme, sans React, pour
   qu'elles servent partout de la meme facon (contexte, et alertes du
   navigateur emises par UserContext) :
   1. `formeDepuisCible` : la seule traduction cible -> forme d'adresse.
   2. `choisirTexte` : la seule facon de choisir un texte. Une entree du
      dictionnaire porte `fr` (vous, la forme par defaut) et, quand le texte
      s'adresse a l'apprenant, `fr_tu`. Sans `fr_tu`, ou pour l'anglais, on
      rend `fr` ou `en` exactement comme avant.
   Le contexte et le hook qui s'en servent : contexts/FormeAdresseContext.js. */

export const FORME_TU = "tu"
export const FORME_VOUS = "vous"

export const formeDepuisCible = (cible) => (cible === "school" ? FORME_TU : FORME_VOUS)

export const choisirTexte = (entree, langue, forme) => {
  if (!entree || !langue) return entree?.[langue]
  if (forme === FORME_TU) {
    const tu = entree[langue + "_tu"]
    if (tu !== undefined) return tu
  }
  return entree[langue]
}
